import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SharedService } from '@shared/services/shared.service';
import { IHousehold } from 'app/models/household/household';
import { IHousingUnit } from 'app/models/housingunits/housing-unit';
import { HouseholdService } from 'app/services/household-service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'household-missing-lat-long-report',
  templateUrl: './household-missing-lat-long.component.html',
  styleUrls: ['./household-missing-lat-long.component.scss']
})
export class HouseholdMissingLatLongComponent implements OnInit {
  loading: boolean = false;  
  size: number = 0;
  sizeHousingUnits: number = 0;
  searchResults: IHousehold[] = [];
  searchResultsHousingUnits: IHousingUnit[] = [];
  
  displayedColumns: string[] = ['id','address1','city','zip','county'];
  dataSource = new MatTableDataSource<IHousehold>(this.searchResults);
  @ViewChild('TablePaginator') paginator: MatPaginator;
  @ViewChild('TableSort') sort: MatSort;

  displayedColumnsHousingUnits: string[] = ['id','address1','city','zip','county'];
  dataSourceHousingUnits = new MatTableDataSource<IHousingUnit>(this.searchResultsHousingUnits);
  @ViewChild('TablePaginatorHousingUnits') paginatorHousingUnits: MatPaginator;
  @ViewChild('TableSortHousingUnits') sortHousingUnits: MatSort;

  constructor(private householdService: HouseholdService,
    public dialog: MatDialog,private sharedService: SharedService,
    private toastr: ToastrService ) { 
  }

  ngOnInit(): void {
    this.loadReport();
    this.loadReportHousingUnits();
    
  }
  
  loadReport() {
    this.loading = true;

    this.householdService.getMissingLatLongReport().subscribe(
      result => {
        this.searchResults = result;
        this.size = result.length;
      },
      error => {
        this.toastr.error(error.message)
        this.loading = false;
      },
      () => {
        this.dataSource = new MatTableDataSource<IHousehold>(this.searchResults);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.loading = false;
      }
    );
  }

  loadReportHousingUnits() {
    this.loading = true;

    this.householdService.getMissingLatLongReportHousingUnit().subscribe(
      result => {
        this.searchResultsHousingUnits = result;
        this.sizeHousingUnits = result.length;
      },
      error => {
        this.toastr.error(error.message)
        this.loading = false;
      },
      () => {
        this.dataSourceHousingUnits = new MatTableDataSource<IHousingUnit>(this.searchResultsHousingUnits);
        this.dataSourceHousingUnits.paginator = this.paginatorHousingUnits;
        this.dataSourceHousingUnits.sort = this.sortHousingUnits;
        this.loading = false;
      }
    );
  }

  updateAll() {
    this.sharedService.openConfirm("Are you sure you want to start this process for Households?");
    this.sharedService.confirmed().subscribe(confirmed => {
      if (confirmed) {
        this.householdService.updateAllMissingLatLong();
        this.toastr.success('Household Process started.  Refresh to monitor the progress.  This may take a few minutes.');
      }
    });
  }

  updateAllHousingUnits() {
    this.sharedService.openConfirm("Are you sure you want to start this process for Housing Units?");
    this.sharedService.confirmed().subscribe(confirmed => {
      if (confirmed) {
        this.householdService.updateAllMissingLatLongHousingUnits();
        this.toastr.success('Housing Unit Process started.  Refresh to monitor the progress.  This may take a few minutes.');
      }
    });
  }
}